import React from 'react';

import {
  Button,
  Group,
  Paper,
  Stack,
  Title
} from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import CareManagerForm from '../components/caremanager/CareManagerForm';

const AddCareManager: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    void navigate('/care_managers');
  };

  const handleCancel = () => {
    void navigate('/care_managers');
  };

  return (
    <Stack gap="md">
      <Group align="center" justify="space-between">
        <Title order={1}>Add New Care Manager</Title>
        <Button variant="outline" onClick={() => void navigate('/care_managers')}>
          Back to All Care Managers
        </Button>
      </Group>

      <Paper withBorder p="xl">
        <Stack gap="lg">
          <CareManagerForm
            mode="add"
            onCancel={handleCancel}
            onSuccess={handleSuccess}
          />
        </Stack>
      </Paper>
    </Stack>
  );
};

export default AddCareManager;
